import React from 'react';
import Banner from '../home-2/Banner';
import ScheduleTwo from '../home-2/ScheduleTwo';
import ServicesTwo from '../home-2/ServicesTwo';
import EventTwo from '../home-2/EventTwo';
import CounterOne from '../home-2/CounterOne';
import Brand from '../home-2/Brand';
import ConferenceOne from '../home-2/ConferenceOne';
import GalleryTwo from '../home-2/GalleryTwo';
import Testimonial from '../home-2/Testimonial';
import VideoOne from '../home-2/VideoOne';
import TeamTwo from '../home-2/TeamTwo';
import PricingOne from '../home-2/PricingOne';
import BlogTwo from '../home-2/BlogTwo';


const HomeTwoMain = () => {
	return (
		<>
		<Banner />
		<ScheduleTwo />
		<ServicesTwo />
		<EventTwo />
		<CounterOne />
		<Brand />
		<ConferenceOne />
		<GalleryTwo />
		<Testimonial />
		<VideoOne />
		<TeamTwo />
		<PricingOne />
		<BlogTwo />
		</>
	);
}

export default HomeTwoMain;
